
import React from 'react';

const MissionSection = () => {
  return (
    <section className="border-t border-border/60 px-5 py-16 md:px-8 md:py-24" aria-labelledby="mission-title">
      <div className="mx-auto grid max-w-6xl items-start gap-9 md:grid-cols-[minmax(12rem,0.65fr)_minmax(0,1.35fr)] md:gap-16 lg:gap-24">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase text-primary">Why we exist</p>
          <h2 id="mission-title" className="text-3xl font-medium md:text-4xl">Our Mission</h2>
        </div>
        <div className="max-w-3xl">
          <p className="mb-6 text-lg leading-8">
            The hardest part of a paper is rarely producing a first draft. It is finding the right evidence, making the argument precise, seeing what does not hold up, and revising without losing the thread.
          </p>
          <p className="text-lg leading-8 text-muted-foreground">
            PaperVerse helps researchers move from evidence to a stronger manuscript without giving up control. It can search, write, calculate, compile, and critique. The researcher decides what is true, what belongs in the paper, and when the work is ready to publish.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
